export default {"src":"/_next/static/media/negative-circle.a237ec94.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};